import type { HTMLAttributes, ReactNode } from "react";
import styles from "./ChatFloatingHeader.module.css";
import { cx } from "../cx";
import { IconChevronLeftLine, IconDot3HorizontalLine } from "../icons/Icon";
import { BrickPill } from "./BrickPill";

export type ChatFloatingHeaderProps = HTMLAttributes<HTMLElement> & {
  name: ReactNode;
  /** 1차: 모델명(노크). 3차: 단계. */
  subtitle?: ReactNode;
  avatar?: ReactNode;
  brickCount?: number | string;
  /** 3차 철벽 링 슬롯. 1차에서는 넘기지 않는다. */
  wall?: ReactNode;
  onBack?: () => void;
  onMenu?: () => void;
  /** 스크롤 배경(F03-24): 불투명도는 CSS 변수 --chat-header-bg-opacity(0~1, 기본 0)로 받는다. */
  scrollBackground?: boolean;
};

/** 채팅방 플로팅 헤더 (Figma 739:62 — scroll=top 108:4884 / scrolled 739:44). 이미지 위 글래스 버튼. */
export function ChatFloatingHeader({ name, subtitle, avatar, brickCount, wall, onBack, onMenu, scrollBackground = false, className, ...rest }: ChatFloatingHeaderProps) {
  return (
    <header className={cx(styles.root, className)} data-scroll-bg={scrollBackground || undefined} {...rest}>
      <button type="button" className={styles.glassButton} aria-label="뒤로" onClick={onBack}>
        <IconChevronLeftLine size={20} />
      </button>
      {avatar && <div className={styles.avatar}>{avatar}</div>}
      <div className={styles.identity}>
        <p className={styles.name}>{name}</p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
      <div className={styles.spacer} />
      {wall}
      {brickCount !== undefined && <BrickPill variant="glass" count={brickCount} />}
      <button type="button" className={styles.glassButton} aria-label="메뉴" onClick={onMenu}>
        <IconDot3HorizontalLine size={20} />
      </button>
    </header>
  );
}
